import ErrorMessage from '../../../../../../components/UI/ErrorMessage';
import { AcademicRestrictionsProps } from '../types';

export function AcademicRestrictions({
  isAcademic,
  isAuthenticated,
  tab,
  source,
  sourceCurated,
  sourceOpen,
}: AcademicRestrictionsProps) {
  if (isAcademic && isAuthenticated && tab === 'CHEMICALS') {
    return (
      <ErrorMessage
        title="This content is not available with your current plan"
        subtitle={
          <div className="text-center">
            <p>Upgrade your plan to access this feature.</p>
            <span>
              <button className="btn-gradient-pink">
                <a href="/plans" className="text-white">
                  Upgrade your plan
                </a>
              </button>
            </span>
          </div>
        }
      />
    );
  }

  if (isAcademic && tab !== 'CHEMICALS' && sourceOpen) {
    return (
      <ErrorMessage
        title=""
        subtitle={
          <p style={{ fontSize: '18px', color: 'rgb(190,0,128)' }}>
            You are viewing a subset of the available sources. Do you want to access all sources?
            <a href="/academic-plans" style={{ color: '#0d1661' }}>
              {' '}
              Upgrade your account{' '}
            </a>
          </p>
        }
      />
    );
  }

  return null;
}